export default defineAppConfig({
  ui: {
    colors: {
      primary: 'blue',
      warning: 'orange'
    },
    selectMenu: {
      slots: {
        content: 'min-w-fit',
      },
    },
    badge: {
      slots: {
        label: 'whitespace-normal',
      },
    },
    table: {
      slots: {
        tbody:
          'divide-y divide-neutral-200 [&>tr]:data-[selectable=true]:hover:cursor-pointer',
        th: 'first:pl-6 last:pr-6 whitespace-nowrap py-2.5 text-sm',
        td: 'first:pl-6 last:pr-6 whitespace-normal align-top py-2',
      },
    },
  },
})
